var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27498 9.72511C6.56748 9.43261 6.56748 8.96011 6.27498 8.66761L3.37248 5.75011H14.75C15.1625 5.75011 15.5 5.41261 15.5 5.00011C15.5 4.58761 15.1625 4.25011 14.75 4.25011H3.37248L6.28248 1.34011C6.57498 1.04761 6.57498 0.575107 6.28248 0.282607C5.98998 -0.00989258 5.51748 -0.00989258 5.22498 0.282607L1.02498 4.47511C0.732478 4.76761 0.732478 5.24011 1.02498 5.53261L5.21748 9.72511C5.50998 10.0101 5.98998 10.0101 6.27498 9.72511Z",
    fill: "#727981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/leftArrowIcon.523c76d9.svg";
export { ForwardRef as ReactComponent };